<template>
  <FormItemWrapper>
    <FormItemLabel slot="label">{{ $t('formItemLabelReactiveEnergy') }}</FormItemLabel>
    <Tooltip
      v-if="$t('formItemTooltipPowerMeasurement')"
      slot="tooltip"
      :content="$t('formItemTooltipPowerMeasurement')"
    />
    <el-select
      v-model="reactiveEnergyTypes"
      :placeholder="$t('formItemPowerMeasurementPlaceholder')"
    >
      <el-option
        v-for="(item, index) in reactiveEnergyType"
        :key="`item-${index}`"
        :label="$t(item.name)"
        :value="item.id"
      />
    </el-select>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { Select, Option } from 'element-ui';
// Components
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Select);
Vue.use(Option);

export default {
  name: 'FilterReactiveEnergy',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  data() {
    return {
      reactiveEnergyType: [
        { id: 'with', name: 'reactiveEnergyWith' },
        { id: 'without', name: 'reactiveEnergyWithout' },
      ],
    };
  },
  computed: {
    reactiveEnergyTypes: {
      get() {
        return this.$store.state.filter.reactiveEnergyType;
      },
      set(value) {
        this.$store.commit('filter/SET_REACTIVE_ENERGY_TYPE', value);
        // this.$store.commit('reactive/SET_REACTIVE_HT', Number(0));
        // this.$store.commit('reactive/SET_REACTIVE_LT', Number(0));
      },
    },
    selectedLanguage() {
      return this.$i18n.locale();
    },
  },
};
</script>
